"use client";

import { AlertDialog, AlertDialogContent } from "@/components/ui/alert-dialog";
import NoticeContent from "./NoticeContent";
import type { NoticeDialogProps } from "./NoticeTypes";

export default function NoticeDialogDesktop(props: NoticeDialogProps) {
  const { open, onOpenChange } = props;
  const handleClose = () => onOpenChange(false);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-3xl border-0 bg-white px-6 py-8 shadow-xl">
        <NoticeContent layout="dialog" onClose={handleClose} {...props} />
      </AlertDialogContent>
    </AlertDialog>
  );
}
